import React from 'react';
import QRious from 'qrious';

class QR extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.drawQR = this.drawQR.bind(this);
  }

  componentDidMount() {
    this.qr = new QRious({
      element: this.canvasRef.current,
      level: this.props.level,
      size: this.props.width,
    });
    this.drawQR();
  }

  componentDidUpdate() {
    this.drawQR();
  }

  drawQR() {
    // console.log('drawQr', this.props.data);
    this.qr.value = this.props.data;
  }

  render() {
    return (
      <canvas
        ref={this.canvasRef}
        width={this.props.width}
        height={this.props.width}
      />
    );
  }
}

QR.defaultProps = {
  width: 400,
  height: 400,
  // data: 'test'
};

export default QR;
